import moment from 'moment'

export const Expense = {
    id: '',
    name: '',
    remarks: '',
    category: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}